import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PatchedTeacherActivity } from '@isophi/pap-api';
import { SelfReflectionForm, SelfReflectionFormValue } from '../../constants/forms';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'isophi-app-portfolio-plan-self-reflection',
    templateUrl: './portfolio-plan-self-reflection.component.html',
    styleUrls: ['./portfolio-plan-self-reflection.component.scss'],
    standalone: false
})
export class PortfolioPlanSelfReflectionComponent implements OnInit {
  @Input()
  form!: FormGroup<SelfReflectionForm>;

  @Input()
  allowEditMode = true;

  @Output()
  requestSave$ = new EventEmitter<Partial<PatchedTeacherActivity>>();

  private initValue!: SelfReflectionFormValue;

  ngOnInit(): void {
    this.initValue = this.copyFormValue();
  }

  private copyFormValue(): SelfReflectionFormValue {
    return structuredClone(this.form.getRawValue());
  }

  cancel(): void {
    this.form.reset(this.initValue);
  }

  save(): void {
    this.initValue = this.copyFormValue();
    this.requestSave$.emit(this.form.value as Partial<PatchedTeacherActivity>);
  }
}
